package com.exura.features.firebase.usecase

import com.exura.features.newauth.domain.manager.AuthManager
import com.exura.features.newauth.domain.model.AuthState
import dev.gitlive.firebase.firestore.DocumentReference
import dev.gitlive.firebase.firestore.FirebaseFirestore
import kotlinx.coroutines.flow.filterIsInstance
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.mapNotNull


class GetUserDataPrefixUseCase(
    private val authManager: AuthManager,
    private val firestore: FirebaseFirestore,
) {

    suspend operator fun invoke(): Result<DocumentReference> = runCatching {
        val user = authManager.state
            .filterIsInstance<AuthState.Authenticated>()
            .mapNotNull { it.user }
            .first()
        firestore.collection(user.userRole.id).document(user.id)
    }
}
